import "./Footer.css";
import { Link } from "react-router";

import DialogContact from "./ContactDialog";

const Footer = () => {
  return (
    <footer className="footer">
      <div className="column">
        <h5 className="white !text-primary-950">About us</h5>
        <h6>
          <Link to="https://discord.gg/eafSXxrB3F" target="_blank">
            Community
          </Link>
        </h6>
        <h6>
          <Link to="/blog">Blog</Link>
        </h6>
      </div>
      <div className="column">
        <h5 className="white !text-primary-950">Help</h5>
        <h6>
          <Link to="/help">Help & Tutorials</Link>
        </h6>
        <h6>
          <Link to="https://discord.gg/eafSXxrB3F" target="_blank">
            Discord
          </Link>
        </h6>
        <h6>
          <DialogContact email="stefandjokovic@flashka.ai" />
        </h6>
      </div>
      <div className="column">
        <h5 className="white !text-primary-950">Social</h5>
        <h6>
          <Link to="https://www.instagram.com/flashka_ai" target="_blank">
            Instagram
          </Link>
        </h6>
        <h6>
          <Link to="https://www.tiktok.com/@flashka_ai" target="_blank">
            TikTok
          </Link>
        </h6>
        <h6>
          <Link
            to="https://www.linkedin.com/company/flashka-ai"
            target="_blank"
          >
            LinkedIn
          </Link>
        </h6>
      </div>
      <div className="column">
        <h5 className="white !text-primary-950">Policies</h5>
        <h6>
          <Link to="/terms">Terms & Conditions</Link>
        </h6>
        <h6>
          <Link to="/privacy">Privacy Policy</Link>
        </h6>
      </div>
    </footer>
  );
};

export default Footer;
